// src/features/records/components/FloatingActionButton.js
import React from 'react';
import { Plus } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import styles from './FloatingActionButton.module.css';

const FloatingActionButton = ({ onClick }) => {
  const { t } = useTranslation();

  return (
    <div className={styles.fabContainer}>
      <button 
        className={styles.fab} 
        onClick={onClick}
        aria-label={t('records.actions.create_record_aria')}
      >
        <Plus size={24} strokeWidth={3} />
      </button>
    </div>
  );
};

export default FloatingActionButton;
